import { useNavigate } from 'react-router-dom';
import { useTranslations } from '@altermaind/core/i18n';
import { Card, Typography } from '@altermaind/web/ui';
import { RenderLocalesWithComponents } from '@/_shared/components/RenderLocalesWithComponents';
import { Routes } from '@/_shared/constants/routes';

export const EmptyStateNoPeople = () => {
  const t = useTranslations('departments.emptyStateNoPeople');
  const navigate = useNavigate();

  const goToPeople = () => {
    navigate(Routes.People);
  };

  return (
    <Card data-testid='empty-state-no-people' textAlign='center' bg='transparent'>
      <Typography variant='h1' mb='s'>
        {t('title')}
      </Typography>
      <Typography variant='p2/light' mb='s'>
        {t('descriptionLine1')}
      </Typography>
      <Typography variant='p2/light'>
        <RenderLocalesWithComponents
          text={t('descriptionLine2', {
            downloadFile: '!{CTA}!',
          })}
          placeholders={{
            '!{CTA}!': (
              <Typography
                as='span'
                color='primary'
                data-testid='go-to-people-link'
                fontWeight='500'
                style={{ textDecoration: 'underline', cursor: 'pointer' }}
                onClick={goToPeople}
              >
                {t('ctaLabel')}
              </Typography>
            ),
          }}
        />
      </Typography>
    </Card>
  );
};
